import { api } from './api'
import { Note, NoteCreate, PaginatedResponse, NoteType } from '@/types'

export interface NoteSearchParams {
  patient_id?: string
  appointment_id?: string
  note_type?: NoteType
  author_id?: string
  search?: string
  skip?: number
  limit?: number
}

export const noteApi = {
  getNotes: async (params?: NoteSearchParams): Promise<PaginatedResponse<Note>> => {
    const searchParams = new URLSearchParams()
    
    if (params?.patient_id) searchParams.append('patient_id', params.patient_id)
    if (params?.appointment_id) searchParams.append('appointment_id', params.appointment_id)
    if (params?.note_type) searchParams.append('note_type', params.note_type)
    if (params?.author_id) searchParams.append('author_id', params.author_id)
    if (params?.search) searchParams.append('search', params.search)
    if (params?.skip !== undefined) searchParams.append('skip', params.skip.toString())
    if (params?.limit !== undefined) searchParams.append('limit', params.limit.toString())
    
    return api.get(`/notes?${searchParams.toString()}`)
  },
  
  getPatientNotes: async (
    patientId: string,
    skip = 0,
    limit = 100,
    appointmentId?: string
  ): Promise<PaginatedResponse<Note>> => {
    const searchParams = new URLSearchParams()
    searchParams.append('skip', skip.toString())
    searchParams.append('limit', limit.toString())
    if (appointmentId) searchParams.append('appointment_id', appointmentId)
    return api.get(`/notes/patient/${patientId}?${searchParams.toString()}`)
  },
  
  getNote: async (id: string): Promise<Note> => {
    return api.get(`/notes/${id}`)
  },
  
  createNote: async (data: NoteCreate): Promise<Note> => {
    return api.post('/notes', data)
  },
  
  updateNote: async (id: string, data: Partial<NoteCreate>): Promise<Note> => {
    return api.put(`/notes/${id}`, data)
  },
  
  deleteNote: async (id: string): Promise<void> => {
    return api.delete(`/notes/${id}`)
  },
}
